<div class="fee-per-cart-value-container">
  <form [formGroup]="formGroup">
    <div [formGroupName]="fieldSetName">
      <pdq-checkbox
        labelSize="medium"
        formControlName="enabled"
        [checked]="formGroup.value.feePerCartValue.enabled"
        label="Add cost by cart value"></pdq-checkbox>
      @if (formGroup.value.feePerCartValue.enabled) {
        <div>
          <div class="row">
            Add
            <pdq-input-arrows
              [symbol]="'%'"
              formControlName="amount"
              precision="2"
              min="0"
              max="100"
              widthSize="auto"
              width="120"></pdq-input-arrows>
            additional shipping cost based on cart value
          </div>
        </div>
      }
    </div>
  </form>
</div>
